<sh-progress-label *ngIf="useProgress$ | async; else status" [type]="labelType$ | async" [percentage]="cell.percentage">{{label$ | async}}</sh-progress-label>

<ng-template #status>
    <sh-label [type]="labelType$ | async">{{label$ | async}}</sh-label>
</ng-template>
